import { Skeleton } from "@mui/material"
import { FC } from "react";

interface TextFieldSkeletonProps {
  shouldAddTopMargin?: boolean;
}

export const TextFieldSkeleton: FC<TextFieldSkeletonProps> = ({ shouldAddTopMargin = true}) => {
  const marginTop = shouldAddTopMargin ? "mt-4" : ""
  const className = `w-full h-[52px] ${marginTop}`
  
  return (
    <Skeleton variant="rounded" className={className} />
  )
}
